import * as React from 'react';
import { SVGProps } from 'react';

const SvgSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.847 21.77a6.314 6.314 0 0 1-6.307-6.306 6.315 6.315 0 0 1 6.307-6.307 6.315 6.315 0 0 1 6.306 6.307 6.314 6.314 0 0 1-6.306 6.306Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M22.113 26.137v8.738h-4.549v-9.307l-.543-.156A10.383 10.383 0 0 1 9.5 15.463 10.355 10.355 0 0 1 19.839 5.125a10.355 10.355 0 0 1 10.338 10.339 10.375 10.375 0 0 1-7.52 9.952l-.544.156v.565Z"
    />
    <path fill={props.fill} d="M28.451 27.56H13.794v4.033H24.4l4.052-4.032Z" />
  </svg>
);

export default SvgSymbol;
